import {
  SendSubscriptionBundlePushNotificationMutation,
  useSendSubscriptionBundlePushNotificationMutation,
} from 'generated/graphql';
import { FetchResult } from '@apollo/client';

type PushNotificationModel = {
  sendNotification: (p: {
    bundleId: number;
    message: string;
  }) => Promise<FetchResult<SendSubscriptionBundlePushNotificationMutation>>;
};

export const usePushNotificationModel = (): PushNotificationModel => {
  const [sendSubscriptionBundlePushNotification] =
    useSendSubscriptionBundlePushNotificationMutation();

  const sendNotification = ({
    bundleId,
    message,
  }: {
    bundleId: number;
    message: string;
  }) =>
    sendSubscriptionBundlePushNotification({
      variables: {
        bundleId,
        message,
      },
    });

  return {
    sendNotification,
  };
};
